import { render, staticRenderFns } from "./ManageTrialNotificationPreferences.vue?vue&type=template&id=74cbcb2b&scoped=true&"
import script from "./ManageTrialNotificationPreferences.vue?vue&type=script&lang=js&"
export * from "./ManageTrialNotificationPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ManageTrialNotificationPreferences.vue?vue&type=style&index=0&id=74cbcb2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cbcb2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDataTable,VRow,VSwitch})
